import { setAccessToProtectedRoutes } from '../../../../store/auth/slice';
import MotionWrapper from '../../../../layouts/MotionWrapper';
import { useLocation, useNavigate } from 'react-router-dom';
import { TypographyLogo } from '../../../../assets/icons';
import { useDispatch } from '../../../../store/store';
import Button from '../../../../components/Button';
import styles from './style.module.scss';

function Approval() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || '/workspace';

    const navigateToDashboard = () => {
        navigate(from);
        dispatch(setAccessToProtectedRoutes(false));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <TypographyLogo />
            <span className={styles.title}>
                Congratulation! Now you are one of us! <br />
                Your sign up information registered successfully
            </span>
            <Button
                type='Primary'
                className={styles.CTA}
                text='Navigate to dashboard'
                onClick={navigateToDashboard}
            />
        </MotionWrapper>
    )
};

export default Approval;
